'use client';
var styles = {"article":"CenterModalContents-module_article__kord2","title":"CenterModalContents-module_title__0K9dv","description":"CenterModalContents-module_description__HDvny","sub-text":"CenterModalContents-module_sub-text__Z-1by","area":"CenterModalContents-module_area__P6-bF","type-scroll":"CenterModalContents-module_type-scroll__KvMHt","gradation":"CenterModalContents-module_gradation__QXgrA"};

export { styles as default };
